document.addEventListener('DOMContentLoaded', function() {

    const load_btn = document.querySelector(".custom-filter-load-more");
    const infinite_scroll = document.querySelector('.infinite-scroll');
    let articles_on_page = document.querySelector('.article-grid');
    let url = articles_on_page.getAttribute('data-next-url');
    const spinner = document.querySelector('.load-more-spinner');

    const load_more = () => {
        spinner.classList.add("show");

        fetch(url)
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(function (data) {
                const html = document.createElement('div');
                html.innerHTML = data;

                let links = html.querySelector('.pagination-links').innerHTML;
                document.querySelector('.pagination-links').innerHTML = links;

                let new_grid = html.querySelector('.article-grid');
                url = new_grid.getAttribute('data-next-url');
                if (url === '') {
                    load_btn.style.display = 'none';
                }
                let new_articles = new_grid.querySelectorAll(".article-card");

                new_articles.forEach(new_prod => {
                    articles_on_page.append(new_prod);
                });
                spinner.classList.remove("show");
            })
            .catch(function (error) {
                window.log(error);
            });
    }

    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }

        load_btn.addEventListener("click", ()=> {
            load_more();
        });

        if (infinite_scroll) {
            // Intersection Observer
            const options = {
                root: null,
                rootMargin: '300px',
                threshold: 0.1
            }

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        load_more();
                    }
                });
            }, options);

            observer.observe(infinite_scroll);
        }


    }
})